import styled from 'styled-components/macro';
import { Container as BaseContainer } from 'reactstrap';
import { theme } from 'styled-tools';

export const Container = styled(BaseContainer)`
  margin-top: 2rem;
`;

export const PageWrapper = styled.div`
  background-color: ${theme('colors.backgroundGray')};
  height: 100%;
  padding-top: 5rem;
`;
